import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=28d71f60&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=28d71f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d71f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d71f60')) {
      api.createRecord('28d71f60', component.options)
    } else {
      api.reload('28d71f60', component.options)
    }
    module.hot.accept("./Coupons.vue?vue&type=template&id=28d71f60&scoped=true&", function () {
      api.rerender('28d71f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/StatisticsChildren/Coupons.vue"
export default component.exports